// Галочка с подписью: «Причина подтверждена документом», «Показывать уволенных».
//
// Заведена 25.08.2026. До неё галочек в продукте было ПЯТЬ реализаций трёх размеров: примитив
// дизайн-системы, обёртка над ним для строк реестра, и три раза голый `<input type=checkbox>` —
// один без класса вовсе. В очереди приёмки «отметить все» и галочки строк были РАЗНЫМИ
// компонентами на одном экране: системная и самодельная на четыре точки мельче.
//
// Цель нажатия — вся строка вместе с подписью, а не квадратик 16 точек: в подпись целятся чаще,
// чем в саму галочку.

import type { ReactNode } from 'react';

import * as Checkbox from '@/shared/ui/checkbox';

export interface CheckboxFieldProps {
  id: string;
  label: ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** Пояснение под подписью: чем обернётся отметка. */
  hint?: ReactNode;
  disabled?: boolean;
}

export function CheckboxField({
  id,
  label,
  checked,
  onCheckedChange,
  hint,
  disabled,
}: CheckboxFieldProps) {
  return (
    <div className='flex items-start gap-2'>
      <span className='flex h-5 shrink-0 items-center'>
        <Checkbox.Root
          id={id}
          checked={checked}
          disabled={disabled}
          onCheckedChange={(next) => onCheckedChange(next === true)}
        />
      </span>
      <label htmlFor={id} className='flex min-w-0 cursor-pointer flex-col gap-0.5'>
        <span className='text-paragraph-sm text-text-strong-950'>{label}</span>
        {hint !== undefined && <span className='text-paragraph-xs text-text-soft-400'>{hint}</span>}
      </label>
    </div>
  );
}
